
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.038 2H6.375a1.755 1.755 0 00-1.75 1.75v24.5A1.755 1.755 0 006.375 30h19.25a1.755 1.755 0 001.75-1.75V6.856zm.525 2.844l1.663 1.531h-1.663zM6.375 28.25V3.75h14.438v4.375h4.813V28.25z","fill":"#c2c2c2"}}),_c('path',{attrs:{"fill":"#829ec2","d":"M8.125 15.097h13.076v1.75H8.125zM8.125 24.439h9.762v1.75H8.125zM8.125 19.763h15.75v1.75H8.125zM8.125 10.23h15.75v1.75H8.125z"}})])
          )
        }
      }
    